import PersonneDetailController from './personne.detail.controller';

export default {
    template: require('./personne.detail.html'),
    controller: PersonneDetailController
};
